export const RESTAURANT_FULLNAME = process.env.REACT_APP_RESTAURANT_FULLNAME
export const RESTAURANT_ID = process.env.REACT_APP_RESTAURANT_ID

export enum PREDEFINED_SHIFTS {
    CUSTOM = "CUSTOM",
    DAY = "J",
    EVENING = "S",
    DOUBLE = "MS",
}

export const PREDEFINED_SHIFTS_VALUES: Record<PREDEFINED_SHIFTS, 
{
    start: number,
    end: number,
    duration: number,
    shiftName: string | null,

    isDouble?: boolean,
    doubleStart?: number,
    doubleEnd?: number,
    doubleDuration?: number
}
> = {
    [PREDEFINED_SHIFTS.CUSTOM]: { start: 11, end: 15, duration: 4, isDouble: false, shiftName: null },
    [PREDEFINED_SHIFTS.DAY]: { start: 10, end: 18, duration: 8, isDouble: false, shiftName: "J" },
    [PREDEFINED_SHIFTS.EVENING]: { start: 16, end: 25, duration: 8, isDouble: false, shiftName: "S" },
    [PREDEFINED_SHIFTS.DOUBLE]: { start: 12, end: 15, duration: 3, isDouble: true, doubleStart: 18, doubleEnd: 25, doubleDuration: 8, shiftName: "MS" },
}